export default __webpack_public_path__ + "static/media/114.7d79d150.gif";